/**
 * @file   src\components\PaymentfailModal.tsx
 * @brief  Payment fail Modal component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { Button, Modal, useNavigate, useParams } from "../utils/thirdpartyComponents";
import { pageURLs } from "src/utils/pageUrls";


const PaymentfailModal = (props: any) => {

    // Initialize useNavigate
    const navigate = useNavigate();
    // Route information variable
    const params = useParams();

    const { show, onHide } = props;
    const handleOnHide = () => {
        onHide();
    }

    const handleOkButtonClick = ()=>{
        navigate("/"+params.carwashname+"/"+pageURLs.subscriptionandwashprice, { state: { showSingleWash: true } });
    }

  return (
    <Modal
        show={show}
        onHide={handleOnHide}
        centered
        className='notification-modal'
    >
        <Modal.Body className='text-center'>
        <h6>Your last purchase payment was not completed successfully. Please try to make the purchase again. </h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
        <Button variant="light" className="m-0" onClick={handleOnHide}>Close</Button>
        <Button variant="primary" className='primary-btn btn-main m-0' onClick={handleOkButtonClick}>Purchase</Button>
        </Modal.Footer>
    </Modal>
  );
};
export default PaymentfailModal;
